module.exports = "../images/fishing-lodge-04.jpg?v=c58dec5";